import scrollElementToTop from './scrollElementToTop';
import scrollWindowToTop from './scrollWindowToTop';

export default () => {
    const element: HTMLElement = document.querySelector('.show .modal-body');
    if (element) {
        scrollElementToTop(element);
    } else {
        scrollWindowToTop();
    }
};
